import { render, staticRenderFns } from "./AddMoveableTarget.vue?vue&type=template&id=40802310&"
import script from "./AddMoveableTarget.vue?vue&type=script&lang=js&"
export * from "./AddMoveableTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports